import { render, staticRenderFns } from "./index.vue?vue&type=template&id=28254c6e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28254c6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28254c6e')) {
      api.createRecord('28254c6e', component.options)
    } else {
      api.reload('28254c6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=28254c6e&scoped=true&", function () {
      api.rerender('28254c6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/index.vue"
export default component.exports